export default __webpack_public_path__ + "static/828_1-ba78e073277e32abcb8bbfb73ae76356.gif";